module.exports = __webpack_public_path__ + "img/senalando-izqhn.png.e4e53af1.webp";